import { createI18n } from './components/i18n';

export const { t, Trans } = createI18n(
  import.meta.glob('../locales/**/*.json', { import: 'default' }),
  'root'
);